var safeExternalLink = /(noopener|noreferrer) (noopener|noreferrer)/;
var protocolLink = /^[\w-_]+:/;
module.exports = href;
function href(cb, root) {
    root = root || window.document;
    window.addEventListener('click', function (e) {
        if (e.button && e.button !== 0 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.defaultPrevented)
            return;
        var anchor = function traverse(node) {
            if (!node || node === root)
                return;
            if (node.localName !== 'a' || node.href === undefined) {
                return traverse(node.parentNode);
            }
            return node;
        }(e.target);
        if (!anchor)
            return;
        if (window.location.protocol !== anchor.protocol || window.location.hostname !== anchor.hostname || window.location.port !== anchor.port || anchor.hasAttribute('data-nanohref-ignore') || anchor.hasAttribute('download') || anchor.getAttribute('target') === '_blank' && safeExternalLink.test(anchor.getAttribute('rel')) || protocolLink.test(anchor.getAttribute('href')))
            return;
        e.preventDefault();
        cb(anchor);
    });
}